import {ITemplateCacheService} from "angular";

export const DATE_PICKER_POPUP_TEMPLATE_NAME = "tf-custom-popup-datepicker.html";

export const DATE_PICKER_POPUP_TEMPLATE = `
    <ul class="uib-datepicker-popup dropdown-menu"
        dropdown-nested
        ng-if="isOpen"
        style="display: block"
        ng-style="{top: position.top+'px', left: position.left+'px'}"
        ng-keydown="keydown($event)"
        ng-click="$event.stopPropagation()">
      <li ng-transclude></li>
      <li ng-if="showButtonBar" style="padding:10px 9px 2px" class="uib-button-bar">
        <span class="btn-group pull-left">
			<button type="button"
			        class="btn btn-sm btn-info uib-datepicker-current"
			        ng-click="select('today', $event)"
			        ng-disabled="isDisabled('today')">
                    {{ "date-picker.CURRENT" | translate }}
			</button>
			<button type="button"
			        class="btn btn-sm btn-danger uib-clear"
                    ng-click="select(null, $event)">
                {{ "date-picker.CLEAR" | translate }}
			</button>
		</span>
        <button type="button"
                class="btn btn-sm btn-success pull-right uib-close"
                ng-click="close()">
            {{ "date-picker.CLOSE" | translate }}
        </button>
      </li>
    </ul>
`;

/** @ngInject */
export function datePickerPopupTemplateCaching($templateCache: ITemplateCacheService) {
    $templateCache.put(DATE_PICKER_POPUP_TEMPLATE_NAME, DATE_PICKER_POPUP_TEMPLATE);
}
